import { graphql } from "@opensea/graphql"

export const QuoteReceiptTotalFragment = graphql(
  `
    fragment QuoteReceiptTotal on TotalPrice {
      pricePerToken {
        token {
          unit
          symbol
        }
        usd
      }
    }
  `,
  [],
)
